import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, useTheme } from '@mui/material';
import { DISPLAY_RETURN_POLICY, isFeatureEnabled } from 'utilities/features';
import { buildLegalLink, buildSquareHomeLink } from 'utilities/links';
import { getLocaleString } from 'utilities/locales';
import { MarketCheckbox } from '@market/react';

const Disclaimer = ({
  applicationFlowToken = null,
  disclosureDocumentToken = null,
  paymentSchedule,
  toggleCheckbox = null,
  northernIrelandOrder = false,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const installment = () => {
    const translation_key = disclosureDocumentToken
      ? 'checkout.review.disclaimer.financing_disclosures.installment'
      : 'checkout.review.disclaimer.installment';
    return t(translation_key, {
      hardwareUrl: buildLegalLink('/hardware'),
      privacyUrl: buildLegalLink('/privacy'),
      installmentUrl: `/api/v2/capital-shop/documents/square-installment-sales-agreement/${applicationFlowToken}/${getLocaleString()}`,
      recurringUrl: buildLegalLink(
        '/shop-recurring-electronic-payment-authorization',
      ),
      requestUrl: buildLegalLink('/ddrsa'),
      financingDisclosuresUrl: `/api/v2/capital-shop/documents/${disclosureDocumentToken}/${getLocaleString()}`,
    });
  };

  const purchaseOrder = () =>
    t('checkout.review.disclaimer.purchase_order', {
      hardwareUrl: buildLegalLink('/hardware'),
      privacyUrl: buildLegalLink('/privacy'),
      purchaseOrderUrl: buildLegalLink('/purchase-order-terms'),
    });

  const upfront = () =>
    t('checkout.review.disclaimer.upfront', {
      hardwareUrl: buildLegalLink('/hardware'),
      privacyUrl: buildLegalLink('/privacy'),
    });

  let disclaimerText;
  switch (paymentSchedule) {
    case 'installment': {
      disclaimerText = installment();
      break;
    }
    case 'purchase_order': {
      disclaimerText = purchaseOrder();
      break;
    }
    default: {
      disclaimerText = upfront();
    }
  }

  if (northernIrelandOrder) {
    disclaimerText += ` ${t('checkout.review.disclaimer.northern_ireland', {
      url: buildSquareHomeLink('ie/en'),
    })}`;
  }

  return (
    <div className="paragraph-10">
      <Grid container>
        {disclosureDocumentToken && toggleCheckbox && (
          <Grid item xs={0.8} md={0.6} mb={2}>
            <MarketCheckbox
              onMarketCheckboxValueChange={(event) =>
                toggleCheckbox(event.detail.current)
              }
            />
          </Grid>
        )}
        <Grid item xs={11.2} md={11.4}>
          <div dangerouslySetInnerHTML={{ __html: disclaimerText }} />
        </Grid>
      </Grid>
      {isFeatureEnabled(DISPLAY_RETURN_POLICY) && (
        <div
          style={{ margin: theme.spacing(2, 0) }}
          dangerouslySetInnerHTML={{
            __html: t('checkout.review.return_policy', {
              hardwareUrl: buildLegalLink('/hardware'),
            }),
          }}
        />
      )}
    </div>
  );
};

export default Disclaimer;
